module.exports = __webpack_public_path__ + "img/Dantam Makeover 01.f90a4700.jpg";